import axios from "axios";
import Config from "src/config";

const v3_actionFeedbackAgent = (data) => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v3/ai/feedback`,
        data: data
        });
};

export default v3_actionFeedbackAgent;
